const LeadInsights = ({ call }) => {
    const { call_score: callScore = {} } = call || {};
    const {
        intent_signals: intentSignals = [] || [],
        objections_and_barriers: objectionsAndBarriers = [] || [],
        sentiment_and_tone: sentimentAndTone = [] || [],
        lead_qualification_insights: leadQualificationInsights = [] || []
    } = callScore || {};

    function formatTagLabel(kebabStr) {
        if (typeof kebabStr !== 'string') return '';

        const words = kebabStr.split('-');
        if (words.length === 0) return '';

        // Capitalize the first word's first letter and join with spaces
        const formatted = words
            .map((word, index) => index === 0
                ? word.charAt(0).toUpperCase() + word.slice(1)
                : word)
            .join(' ');

        return formatted;
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <h2 className="text-base font-semibold text-gray-900 mb-4">Lead Insights</h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Left Column */}
                <div className="space-y-4">
                    {/* Prospect Intent */}
                    <div>
                        <h3 className="text-sm font-medium text-gray-900 mb-2">Intent Signals</h3>
                        <div className="flex flex-wrap gap-2">
                            {!intentSignals?.length && (
                                <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-purple-50 text-purple-800 border border-purple-200 rounded-md">
                                    No intent signals found
                                </span>
                            )}
                            {intentSignals?.map((signal) => (
                                <span key={signal} className="inline-flex items-center px-2 py-1 text-xs font-medium bg-purple-50 text-purple-800 border border-purple-200 rounded-md">
                                    {formatTagLabel(signal)}
                                </span>
                            ))}
                        </div>
                    </div>

                    {/* Objections */}
                    <div>
                        <h3 className="text-sm font-medium text-gray-900 mb-2">Concerns Raised</h3>
                        <div className="flex flex-wrap gap-2">
                            {!objectionsAndBarriers?.length && (
                                <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-red-50 text-red-800 border border-red-200 rounded-md">
                                    No concerns raised
                                </span>
                            )}
                            {objectionsAndBarriers?.map((barrier) => (
                                <span key={barrier} className="inline-flex items-center px-2 py-1 text-xs font-medium bg-red-50 text-red-800 border border-red-200 rounded-md">
                                    {formatTagLabel(barrier)}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Right Column */}
                <div className="space-y-4">
                    {/* Sentiment */}
                    <div>
                        <h3 className="text-sm font-medium text-gray-900 mb-2">Prospect Sentiment</h3>
                        <div className="flex flex-wrap gap-2">
                            {!sentimentAndTone?.length && (
                                <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-green-50 text-green-800 border border-green-200 rounded-md">
                                    No sentiment found
                                </span>
                            )}
                            {sentimentAndTone?.map((sentiment) => (
                                <span key={sentiment} className="inline-flex items-center px-2 py-1 text-xs font-medium bg-green-50 text-green-800 border border-green-200 rounded-md">
                                    {formatTagLabel(sentiment)}
                                </span>
                            ))}
                        </div>
                    </div>

                    {/* Qualification */}
                    <div>
                        <h3 className="text-sm font-medium text-gray-900 mb-2">Qualification Status</h3>
                        <div className="space-y-1">
                            {!leadQualificationInsights?.length && (
                                <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-green-50 text-green-800 border border-green-200 rounded-md">
                                    No qualification status found
                                </span>
                            )}
                            {leadQualificationInsights?.map((insight) => (
                                <div className="flex items-center gap-2">
                                    <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                                    <span className="text-sm text-gray-700">
                                        {formatTagLabel(insight)}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LeadInsights;